<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Italian Prince, Wedlocked Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="dedicationPage" id="ded01"><p class="dedicationText"><span>To Anna Marie Allen,</span></p><p class="dedicationText"><span>Aunti <em class="italic"><span><span class="bold"><span>par excellence</span></span></span></em>—</span></p><p class="dedicationText"><span>I couldn’t have written this book without you.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// italianprincewedlockedwife_ded01.vue?1e3f4ec8